import { Common, color } from '@stockbit/ui';
import Link from 'next/link';
import {
  DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER,
  DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER_ACTION,
} from './__tests__/constant';

const { Flex, Text } = Common;

function Header() {
  return (
    <Flex
      justify="space-between"
      mb="16px"
      data-cy={DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER}
    >
      <Text family="bold" size="16px">
        Suggestion For You
      </Text>
      <Link
        href={{
          pathname: '/discover/people',
          query: { tab_selected: 'all' },
        }}
      >
        <Text
          color={color.primary}
          as="a"
          data-cy={DATA_CY_NAME_SUGGESTED_PEOPLE_STREAM_WIDGET_HEADER_ACTION}
        >
          See All
        </Text>
      </Link>
    </Flex>
  );
}

export default Header;
